module.exports = __webpack_public_path__ + "static/media/ic-check-mark-green.6eb34b05.svg";